export class FileNameUtils {
  static getExtensionFromMimeType(mimeType?: string | null): string | null {
    if (!mimeType) return null;

    const normalized = mimeType.split(';')[0].trim().toLowerCase();

    const MIME_TO_EXTENSION: Record<string, string> = {
      'application/pdf': 'pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
      'application/msword': 'doc',
      'text/plain': 'txt',
      'image/jpeg': 'jpg',
      'image/jpg': 'jpg',
      'image/png': 'png',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      'text/csv': 'csv',
      'application/csv': 'csv',
    };

    return MIME_TO_EXTENSION[normalized] ?? null;
  }

  static replaceOrAppendExtension(fileName: string, extension: string): string {
    const trimmed = (fileName ?? '').trim();
    const baseName = trimmed.split(/[\\/]/).pop() || '';

    if (!baseName) return `file.${extension}`;

    const dotIndex = baseName.lastIndexOf('.');
    if (dotIndex > 0) {
      return `${baseName.slice(0, dotIndex + 1)}${extension}`;
    }

    return `${baseName}.${extension}`;
  }

  static ensureExtensionFromBlob(fileName: string, blob: Blob, fallbackExtension = 'pdf'): string {
    const extension = this.getExtensionFromMimeType(blob?.type) ?? fallbackExtension;
    return this.replaceOrAppendExtension(fileName, extension);
  }
}
